import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import Home from './components/Home';
import ProductList from './components/ProductList';
import ProductDetail from './components/ProductDetail';
import Cart from './components/Cart';
import Register from './components/Register';
import Login from './components/Login';
import AdminOrders from './components/AdminOrders';
import AdminProducts from './components/AdminProducts';
import AdminCategories from './components/AdminCategories';
import UserOrders from './components/UserOrders';
import OrderDetail from './components/OrderDetail';
import CategoryProducts from './components/CategoryProducts'; 
import CategoryOrderStats from './components/CategoryOrderStats'; 
import ContactUs from './components/ContactUs';

const AppRouter = () => {
  const isAuthenticated = !!localStorage.getItem('token');
  const isAdmin = localStorage.getItem('role') === 'admin';

  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/products" element={<ProductList />} />
      <Route path="/product/:id" element={<ProductDetail />} />
      <Route path="/cart" element={isAuthenticated ? <Cart /> : <Navigate to="/login" />} />
      <Route path="/register" element={<Register />} />
      <Route path="/login" element={<Login />} />
      <Route path="/admin/orders" element={isAdmin ? <AdminOrders /> : <Navigate to="/" />} />
      <Route path="/admin/products" element={isAdmin ? <AdminProducts /> : <Navigate to="/" />} />
      <Route path="/admin/categories" element={isAdmin ? <AdminCategories /> : <Navigate to="/" />} />
      <Route path="/admin/order/:orderNumber" element={isAdmin ? <OrderDetail /> : <Navigate to="/" />} />
      <Route path="/my-orders" element={isAuthenticated ? <UserOrders /> : <Navigate to="/login" />} />
      <Route path="/order/:orderNumber" element={isAuthenticated ? <OrderDetail /> : <Navigate to="/login" />} />
      <Route path="/category/:categoryId" element={<CategoryProducts />} />
      <Route path="/admin/category-orders/:categoryId" element={<CategoryOrderStats />} /> 
      <Route path="/contact-us" element={<ContactUs />} />
    </Routes>
  );
};

export default AppRouter;
